import type { ContactQuerySchema } from '../schemas';

export const fieldNames: Record<keyof ContactQuerySchema, { name: string; revertible: boolean }> = {
  first_name: { name: 'First Name', revertible: true },
  last_name: { name: 'Last Name', revertible: true },
  status: { name: 'Status', revertible: true },

  username: { name: 'Username', revertible: true },
  email: { name: 'Email', revertible: true },
  title: { name: 'Title', revertible: true },
  linked_in_url: { name: 'LinkedIn', revertible: true },
  twitter_handle: { name: 'X (Twitter)', revertible: true },
  work_anniversary: { name: 'Work Anniversary', revertible: true },
  wedding_anniversary: { name: 'Wedding Anniversary', revertible: true },

  birth_day: { name: 'Birth Day', revertible: true },
  birth_month: { name: 'Birth Month', revertible: true },

  spouse_name: { name: 'Spouse Name', revertible: true },
  children_names: { name: 'Children Names', revertible: true },
  pet_names: { name: 'Pet Names', revertible: true },
  remote_worker: { name: 'Remote Worker', revertible: true },
  registration_date: { name: 'Registration Date', revertible: true },

  interests: { name: 'Interests', revertible: true },
  phone_numbers: { name: 'Phone Numbers', revertible: true },
  addresses: { name: 'Addresses', revertible: true },
  emails: { name: 'Emails', revertible: true },

  // TODO: Need to make contacts_associated_with|friends revertible
  contacts_associated_with: { name: 'Friends', revertible: false },
  friends: { name: 'Friends', revertible: false },

  clients: { name: 'Companies', revertible: true },
  primary_client: { name: 'Companies', revertible: true },
  alternate_clients: { name: 'Companies', revertible: true },

  profile_image: { name: 'Profile Image', revertible: true },

  id: { name: 'ID', revertible: false },
  pivot: { name: 'Pivot', revertible: false },
  freshdesk: { name: 'Freshdesk', revertible: true },

  agreements: { name: 'Agreements', revertible: false },
  marketing_campaigns: { name: 'Marketing Campaigns', revertible: false },
};
